import React from 'react';
import {
  axisClasses,
  barElementClasses,
  BarPlot,
  ChartsTooltip,
  ChartsXAxis,
  ChartsYAxis,
  ResponsiveChartContainer
} from "@mui/x-charts";

import {DashboardPromedioResolucion, DashboardPromedioResolucionFields} from "../types/dashboard";
import CardActions from "../../sistema/components/CardActions";
import {Stack, useTheme} from "@mui/material";
import {hexToRGBA} from "../../../@core/utils/hex-to-rgba";

interface PromedioResolucionPorEtapaProps {
  data: DashboardPromedioResolucion[];
}

function PromedioResolucionPorEtapaChart({data}: PromedioResolucionPorEtapaProps) {
  const theme = useTheme();

  return (
    <CardActions title={'Promedio Resolución'} colapsable>
      <Stack direction={'row'}>
        <ResponsiveChartContainer
          height={400}
          dataset={data}
          series={[
            {
              type: 'line',
              dataKey: DashboardPromedioResolucionFields.CantMensajes,
              label: '# Mensajes',
              id: 'cantMensajes',
              yAxisId: 'cantMensajes',

            },
            {
              type: 'bar',
              dataKey: DashboardPromedioResolucionFields.AtrasoPromedioDias,
              label: "Atraso Promedio (días)",
              id: 'atrasoPromedioDias',
              yAxisId: 'atrasoPromedioDias',
              color: theme.palette.primary.main,
            },
          ]}
          xAxis={[
            {
              scaleType: 'band',
              dataKey: DashboardPromedioResolucionFields.Etapa,
              id: 'x-axis-id',
            },
          ]}
          margin={{left: 70, right: 70}}
          sx={{
            [`.${axisClasses.left} .${axisClasses.label}`]: {
              transform: 'translate(-25px, 0)',
            },
            [`.${axisClasses.right} .${axisClasses.label}`]: {
              transform: 'translate(30px, 0)',
            },
            [`.${barElementClasses.root}`]: {
              fill: hexToRGBA(theme.palette.primary.main, 0.08),
              stroke: hexToRGBA(theme.palette.primary.main, 0.75),
              strokeWidth: 1,
              clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 1px), 0 calc(100% - 1px))' // Magia para eliminar el borde inferior
            },
          }}
          yAxis={[{
            id: 'atrasoPromedioDias',

          }]}
        >
          <BarPlot
          />
          <ChartsTooltip/>

          <ChartsYAxis axisId="atrasoPromedioDias" label="Atraso (días)"/>
          <ChartsXAxis label="Etapas" position="bottom" axisId="x-axis-id"/>

        </ResponsiveChartContainer>

      </Stack>
    </CardActions>
  );
}

export default PromedioResolucionPorEtapaChart;